"use client";

/**
 * Horizontal scroll-snap track. Drag, swipe, or scroll-wheel-horizontally to
 * navigate. Edge-fades into the page bg via a mask gradient.
 *
 * No arrow controls — kept minimal so the slider blends into the page.
 *
 *   <HorizontalSlider>
 *     <article data-slide className="snap-start min-w-[360px] ...">…</article>
 *     ...
 *   </HorizontalSlider>
 */
export function HorizontalSlider({
  children,
}: {
  children: React.ReactNode;
  /** Kept for API compatibility with existing call sites. */
  label?: string;
}) {
  return (
    <div
      className="flex gap-6 overflow-x-auto snap-x snap-mandatory pb-2 -mx-5 px-5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
      style={{
        maskImage:
          "linear-gradient(to right, transparent, black 2%, black 98%, transparent)",
        WebkitMaskImage:
          "linear-gradient(to right, transparent, black 2%, black 98%, transparent)",
      }}
    >
      {children}
    </div>
  );
}
